var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 149,
    viewBox: "0 0 150 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_30_16958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.0005 116C104.271 116 128 92.4985 128 63.5C128 34.5015 104.271 11 75.0005 11C45.7291 11 22 34.5015 22 63.5C22 92.4985 45.7291 116 75.0005 116Z",
    fill: "#FFF6DB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.0004 108.163C99.8478 108.163 119.991 88.1613 119.991 63.5C119.991 38.8386 99.8478 18.8372 75.0004 18.8372C50.1529 18.8372 30.0098 38.8386 30.0098 63.5C30.0098 88.1613 50.1529 108.163 75.0004 108.163Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M120.161 63.3283C120.161 64.1857 120.161 64.8616 119.991 65.7189C118.798 42.1973 99.1994 23.4467 75.1708 23.4467C51.1412 23.4467 31.5436 42.1973 30.1802 65.7189C30.1802 64.8616 30.0098 64.1857 30.0098 63.3283C30.0098 38.788 50.2891 18.8372 75.0004 18.8372C100.052 18.8372 120.161 38.788 120.161 63.3283Z",
    fill: "#ECEFF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9782 61.2811L70.5697 64.6902L49.4373 43.9022C48.4148 42.8733 48.4148 41.3401 49.4373 40.4928C50.4599 39.464 51.9937 39.464 52.8458 40.4928L73.9782 61.2811Z",
    fill: "#FDB600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.26 64.8615L75.8516 61.4524L91.5305 45.9393C92.553 44.9206 94.0869 44.9206 94.939 45.9393C95.9615 46.9682 95.9615 48.5014 94.939 49.3487L79.26 64.8615Z",
    fill: "#FDB600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9553 62.814C74.3186 61.4523 76.1933 61.4523 77.3862 62.814C78.7496 64.1857 78.7496 66.0618 77.3862 67.0805C76.0229 68.0993 74.1482 68.4422 72.9553 67.0805C71.7623 65.8903 71.7623 64.0143 72.9553 62.814Z",
    fill: "#AAB2C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2483 99.1252C85.9075 99.1252 85.5667 98.9537 85.5667 98.6107L74.4892 65.2043C74.3188 64.8614 74.6596 64.357 75.0004 64.1856C75.3413 64.0141 75.8526 64.357 76.023 64.6899L87.0995 98.1064C87.2699 98.4393 86.929 98.9537 86.5892 99.1252C86.4187 99.1252 86.4187 99.1252 86.2483 99.1252Z",
    fill: "#FDB600"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4216 61.2808C73.6371 59.2433 77.0456 59.2433 79.0907 61.2808C81.3062 63.3283 81.3062 66.7374 79.0907 68.9564C76.8752 71.1754 73.4667 71.004 71.4216 68.9564C69.3765 66.9089 69.2061 63.3283 71.4216 61.2808Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9941 63.4695L76.9508 63.4291C76.133 62.602 74.579 62.4911 73.4738 63.5098C72.668 64.2562 72.5833 65.8398 73.5605 66.8182C74.4862 67.7462 75.9787 67.7865 76.9508 66.8182C78.0348 65.7289 77.9067 64.3067 77.0385 63.5098L76.9941 63.4695ZM79.0907 61.2808C77.0456 59.2433 73.6371 59.2433 71.4216 61.2808C69.2061 63.3283 69.3765 66.9089 71.4216 68.9564C73.4667 71.004 76.8752 71.1754 79.0907 68.9564C81.3062 66.7374 81.3062 63.3283 79.0907 61.2808Z",
    fill: "#FDB600"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7039 22.9324H73.9772C73.4659 22.9324 72.9546 23.4468 72.9546 23.9511V31.9698C72.9546 32.4741 73.4659 32.9885 73.9772 32.9885H76.7039C77.2152 32.9885 77.7264 32.4741 77.7264 31.9698V23.7795C77.556 23.2752 77.2152 22.9324 76.7039 22.9324Z",
    fill: "#ECEFF2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7039 93.6685H73.9772C73.4659 93.6685 72.9546 94.1829 72.9546 94.6973V102.706C72.9546 103.22 73.4659 103.725 73.9772 103.725H76.7039C77.2152 103.725 77.7264 103.22 77.7264 102.706V94.6973C77.556 94.1829 77.2152 93.6685 76.7039 93.6685Z",
    fill: "#ECEFF2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4724 60.7766H35.4625C34.9512 60.7766 34.4399 61.2809 34.4399 61.7954V64.5186C34.4399 65.0331 34.9512 65.5475 35.4625 65.5475H43.4724C43.9837 65.5475 44.4949 65.0331 44.4949 64.5186V61.7954C44.4949 61.2809 43.9837 60.7766 43.4724 60.7766Z",
    fill: "#ECEFF2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M115.048 60.948H107.038C106.527 60.948 106.016 61.4523 106.016 61.9667V64.69C106.016 65.2044 106.527 65.7189 107.038 65.7189H115.048C115.559 65.7189 116.071 65.2044 116.071 64.69V61.9667C115.9 61.4523 115.559 60.948 115.048 60.948Z",
    fill: "#ECEFF2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_30_16958",
    x: 0,
    y: 0,
    width: 150,
    height: 149,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238889 0 0 0 0 0.25168 0 0 0 0 0.266667 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_30_16958"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_30_16958",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkExpired);
export default __webpack_public_path__ + "static/media/link_expired.27367b20d358c7093aad7e4364811580.svg";
export { ForwardRef as ReactComponent };